import { useAuth } from '@clerk/nextjs';
import useSWR from 'swr';
import authApiInterface from '../services/auth-api-interface';

export default function useUser() {
  const { getToken, isSignedIn } = useAuth();

  const fetcher = async (getToken: () => Promise<string | null>) => {
    return await authApiInterface.fetchUser(getToken);
  };

  const { data, error, isLoading } = useSWR(isSignedIn ? '/api/v1/user' : null, () =>
    fetcher(getToken),
  );

  return {
    user: data,
    isLoading,
    isError: error,
  };
}
